import Action from '../../actions/provenances'
import { IProvenance } from '../../models/Provenance'
import { ProvenancesActions } from './actionNames'
import initialStore from './initialState'
import provenancesAreAccepted from './mutators/provenancesAreAccepted'
import provenanceAreAccepted from './mutators/provenanceAreAccepted'
import provenancesAreRejected from './mutators/provenancesAreRejected'
import deleteProvenance from './mutators/deleteProvenance'
import requestForProvenances from './mutators/requestForProvenances'
import toggleModal from './mutators/toggleModal'

export default function(
  store: Readonly<IProvenancesStore> = initialStore,
  action: Action & any,
) {
  switch (action.type) {
    case ProvenancesActions.RequestForProvenances:
      return requestForProvenances(store)
    case ProvenancesActions.ProvenancesAreAccepted:
      return provenancesAreAccepted(store, action)
    case ProvenancesActions.ProvenancesAreRejected:
      return provenancesAreRejected(store, action)
    case ProvenancesActions.ToggleProvenancesModal:
      return toggleModal(store, action)
    case ProvenancesActions.AcceptedProvenance:
      return provenanceAreAccepted(store, action)
    case ProvenancesActions.DeletedProvenance:
      return deleteProvenance(store, action)
  }

  return store
}

export interface IProvenancesStore {
  modal: {
    open: boolean
  }
  provenances: IProvenance[]
  request: IRequest
}

interface IRequest {
  isLoading: boolean
  errMessage: string
}
